import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, CardBody } from "reactstrap";

import ALoader from "views/pages/manage/common/a-loader";
import { getBusinessAreasDropdown } from "../manage-receipts/constants";

import { EPMRContext } from "./context";
import Filters from "./Filters";
import { emptySearchFields, getReceiptsList } from "./constants";
import EpmrReceiptsListing from "./EpmrReceiptsListing";

const ManageEpmr = () => {
  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns
  );

  const { globalFilter, setGlobalFilter } = useContext(EPMRContext);

  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [currentPageNumber, setPageNumber] = useState(0);

  const [businessAreaOptions, setBusinessAreaOptions] = useState([]);

  useEffect(() => {
    // initial load
    fetchListFromApi({});

    if (!masterDropdowns?.allBusinessAreaList.length) {
      fetchBUDropdown();
    } else {
      const options = masterDropdowns?.allBusinessAreaList.map(
        ({ label, businessAreaId }) => ({
          label,
          value: businessAreaId,
          businessAreaId,
        })
      );

      setBusinessAreaOptions(options);
    }
  }, []);

  const formatBUDropdown = (response) => {
    const options = response.map((item) => ({
      label: `${item.businessAreaDispValue}`,
      value: item.id,
      businessAreaId: item.id,
    }));

    setBusinessAreaOptions(options);
  };

  const fetchBUDropdown = async () => {
    // setDropdownLoader(true);
    const res = await getBusinessAreasDropdown();
    return formatBUDropdown(res);

    // setDropdownLoader(false);
  };

  const fetchListFromApi = async ({
    filters = {},
    offset = 0,
    buDropdown = businessAreaOptions,
    showOnlyPending = false,
  }) => {
    setIsLoading(true);

    let payload = {
      ...filters,
    };

    if (!filters?.businessAreaId || filters.businessAreaId.length === 0) {
      // handle if user try to submit empty business area because api send all data in that case

      const buDropdown =
        masterDropdowns?.allBusinessAreaList || businessAreaOptions;

      payload = {
        ...filters,
        businessAreaId: buDropdown.map((bu) => bu.businessAreaId),
      };
    }

    const response = await getReceiptsList({ payload, page: offset });

    setIsLoading(false);

    if (response?.code === 200) {
      const { totalRecords, epmrReceiptList } = response.data;

      if (showOnlyPending) {
        const removeCancelledReceipts = epmrReceiptList.filter(
          (receipt) => !receipt.isApproved
        );

        setRowCount(removeCancelledReceipts.length);
        setRows(removeCancelledReceipts);
        return;
      }
      setRowCount(totalRecords);
      setRows(epmrReceiptList);
    } else {
      setRowCount(0);
      setRows([]);
    }
  };

  const onPageChange = (newPage) => {
    setPageNumber(newPage);
    fetchListFromApi({ filters: globalFilter, offset: newPage });
  };

  const updateReceiptsList = (updatedFields = {}, showOnlyPending = false) => {
    setPageNumber(0);
    const newFilter = { ...globalFilter, ...updatedFields };

    fetchListFromApi({ filters: newFilter, offset: 0, showOnlyPending });
  };

  const setFilterForm = (f) => {
    setGlobalFilter({ ...f });
  };

  const crossInputHandler = () => {
    setFilterForm({ ...globalFilter, ...emptySearchFields });

    updateReceiptsList(emptySearchFields);
  };

  const searchInputValueHandler = (updatedFields) => {
    // If you want to update filterForm or other fields, you can pass them in `updateReceiptsList`
    updateReceiptsList(updatedFields);
  };

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 100px)",
      }}
    >
      <Card className="mx-3 mb-2" style={{ flexGrow: 1 }}>
        <CardBody style={{ display: "flex", flexFlow: "column" }}>
          <div className="search-match-container">
            <div
              className={`d-flex align-items-center`}
              style={{ height: "min-content" }}
            >
              <div className="heading-3 color-black-60 text-bold">
                EPMR Receipts
              </div>

              {!isLoading && rows?.length > 0 && (
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    padding: "5px",
                    marginLeft: "0.5rem",
                    backgroundColor: "#f5f5f5",
                    lineHeight: "1.3",
                    fontWeight: 700,
                    textAlign: "center",
                  }}
                >
                  {rows.length}
                </div>
              )}
            </div>

            <Filters
              crossInputHandler={crossInputHandler}
              searchInputValueHandler={searchInputValueHandler}
              isLoading={isLoading}
              businessAreaOptions={businessAreaOptions}
              updateReceiptsList={updateReceiptsList}
            />
          </div>

          {isLoading ? (
            <ALoader />
          ) : (
            <EpmrReceiptsListing
              rows={rows || []}
              isLoading={isLoading}
              rowCount={rowCount || 0}
              onPageChange={onPageChange}
              currentPage={currentPageNumber || 0}
              updateReceiptsList={updateReceiptsList}
              businessAreaOptions={businessAreaOptions}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default ManageEpmr;
